module.exports = __webpack_public_path__ + "assets/3-Los-Angeles-SDR-jobs.12285405.png";